(function() {
  'use strict';

  // State management
  const state = {
    selectedQuantity: 10,
    logoFile: null,
    patchType: '',
    selectedPowerUps: [],
    styleColorSelections: [],
    sizeAllocations: {},
    isStyleConfigComplete: false,
    scrollPositions: {},
    basePricePerHat: 65.00,
    basePriceInCents: 6500,
    ropeAction: '',
    ropeColor: '',
    teeLeatherMaterial: '',
    teeLeatherTitle: '',
    teeLeatherVariantId: null,
    teeLogoChoice: '',
    teeLogoFile: null,
    teeLogoBase64: null
  };

  // Pricing tiers - will be populated from DOM
  let pricingTiers = [];

  // Power-up prices in cents
  const powerUpPrices = {
    'magnetic-ball-marker': 400,
    'tee-hole': 200,
    'branded-tee-holder': 500,
    'rush-production': 500,
    'Change-Rope': 300
  };

  // Power-up identifiers (must match powerup values in theme settings)
  const ROPE_POWERUP_VALUE = 'Change-Rope';
  const TEE_HOLDER_POWERUP_VALUE = 'branded-tee-holder';

  // Patch options with quantity requirements
  const patchOptions = [
    { value: 'leather', minQuantity: 1 },
    { value: 'embroidery', minQuantity: 10 },
    { value: 'fabric', minQuantity: 1 },
    { value: 'rubber', minQuantity: 100 }
  ];

  // Check if a SPECIFIC power-up is a tee product
  function isTeePowerUp(powerUpValue) {
    const powerUpCard = document.querySelector(`[data-powerup="${powerUpValue}"]`);
    if (!powerUpCard) return false;
    
    const titleEl = powerUpCard.querySelector('.powerup-title');
    if (!titleEl) return false;
    
    const title = titleEl.textContent?.trim() || '';
    const isTee = title.toLowerCase().includes('tee');
    
    console.log(`Checking if "${powerUpValue}" is a tee product:`, isTee, `(title: "${title}")`);
    return isTee;
  }

  // Check if ANY tee products exist in the catalog (for UI hints)
  function hasTeProducts() {
    const powerupTitles = document.querySelectorAll('.powerup-title');
    
    for (const titleEl of powerupTitles) {
      const title = titleEl.textContent?.trim() || '';
      if (title.toLowerCase().includes('tee')) {
        return true;
      }
    }
    return false;
  }

  // Initialize on DOM ready
  function init() {
    loadPricingTiersFromDOM();
    setupQuantitySelector();
    setupPatchTypeSelection();
    setupHatCatalog();
    setupPowerUps();
    setupRopeModal();
    setupTeeModal();
    initLogoManager();
    setupScrollButtons();
    setupOrderButtons();
    updatePricing();
  }

  // Load BOTH base price AND pricing tiers from DOM
  function loadPricingTiersFromDOM() {
    // Load base price for cart
    const pricingContainer = document.querySelector('[data-base-price]');
    if (pricingContainer) {
      const priceInCents = parseInt(pricingContainer.dataset.basePrice) || 6500;
      state.basePricePerHat = priceInCents / 100;
      state.basePriceInCents = priceInCents;
    } else {
      state.basePricePerHat = 65.00;
      state.basePriceInCents = 6500;
    }
    
    // Load tier data for display
    const tierCards = document.querySelectorAll('[data-tier-card]');
    pricingTiers = [];
    
    tierCards.forEach(card => {
      const quantity = parseInt(card.dataset.tierQuantity);
      const priceInCents = parseInt(card.dataset.tierPrice);
      
      pricingTiers.push({
        quantity: quantity,
        pricePerHat: priceInCents / 100,
        priceInCents: priceInCents
      });
    });
    
    // Sort by quantity
    pricingTiers.sort((a, b) => a.quantity - b.quantity);
    
    console.log('Base price for cart:', state.basePricePerHat);
    console.log('Display tiers loaded:', pricingTiers.length);
  }

  // Use TIERED pricing for display
  function updatePricing() {
    if (pricingTiers.length === 0) return;
    
    // Find tier for display pricing
    const tier = pricingTiers.slice().reverse().find(t => state.selectedQuantity >= t.quantity) || pricingTiers[0];
    const baseTotal = tier.pricePerHat * state.selectedQuantity;
    
    // Calculate power-up costs (in dollars)
    let powerUpTotal = 0;
    state.selectedPowerUps.forEach(powerUp => {
      const priceInCents = powerUpPrices[powerUp] || 0;
      powerUpTotal += (priceInCents / 100) * state.selectedQuantity;
    });
    
    const grandTotal = baseTotal + powerUpTotal;
    
    // Update UI with TIERED pricing
    const pricePerHatEl = document.querySelector('[data-price-per-hat]');
    const totalPriceEl = document.querySelector('[data-total-price]');
    const startOrderPriceEl = document.querySelector('[data-start-order-price]');
    
    if (pricePerHatEl) pricePerHatEl.textContent = `$${tier.pricePerHat.toFixed(2)}`;
    if (totalPriceEl) totalPriceEl.textContent = `$${grandTotal.toFixed(2)}`;
    if (startOrderPriceEl) startOrderPriceEl.textContent = `$${grandTotal.toFixed(2)}`;
  }

  // Quantity selector functionality
  function setupQuantitySelector() {
    const tierCards = document.querySelectorAll('[data-tier-card]');
    const quantityInput = document.querySelector('[data-quantity-input]');
    const decreaseBtn = document.querySelector('[data-quantity-decrease]');
    const increaseBtn = document.querySelector('[data-quantity-increase]');

    if (tierCards.length > 0) {
      tierCards.forEach(card => {
        card.addEventListener('click', function() {
          const quantity = parseInt(this.dataset.tierQuantity);
          updateQuantity(quantity);
        });
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', function() {
        const value = Math.max(1, parseInt(this.value) || 1);
        updateQuantity(value);
      });
    }

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function() {
        updateQuantity(Math.max(1, state.selectedQuantity - 1));
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', function() {
        updateQuantity(state.selectedQuantity + 1);
      });
    }
  }

  function updateQuantity(newQuantity) {
    state.selectedQuantity = newQuantity;
    
    // Find appropriate pricing tier for visual feedback
    const tier = pricingTiers.slice().reverse().find(t => newQuantity >= t.quantity) || pricingTiers[0];
    
    // Update UI
    const quantityInput = document.querySelector('[data-quantity-input]');
    if (quantityInput) quantityInput.value = newQuantity;
    
    const quantityDisplay = document.querySelector('[data-quantity-display]');
    if (quantityDisplay) quantityDisplay.textContent = newQuantity;
    
    // Update tier selection visual feedback
    document.querySelectorAll('[data-tier-card]').forEach(card => {
      const isSelected = parseInt(card.dataset.tierQuantity) === tier.quantity;
      card.classList.toggle('ring-2', isSelected);
      card.classList.toggle('ring-primary', isSelected);
      card.classList.toggle('bg-primary/5', isSelected);
    });

    // Update patch options availability
    updatePatchOptions();
    
    // Update pricing display
    updatePricing();
  }

  // Patch type selection
  function setupPatchTypeSelection() {
    const patchCards = document.querySelectorAll('[data-patch-type]');
    
    patchCards.forEach(card => {
      card.addEventListener('click', function() {
        const patchType = this.dataset.patchType;
        const minQty = parseInt(this.dataset.minQuantity);
        
        if (state.selectedQuantity >= minQty) {
          state.patchType = patchType;
          updatePatchTypeUI();
          showPatchConfiguration(patchType);
          updateOrderButtonState();
        }
      });
    });
  }

  function updatePatchOptions() {
    const patchCards = document.querySelectorAll('[data-patch-type]');
    
    patchCards.forEach(card => {
      const patchType = card.dataset.patchType;
      const minQty = parseInt(card.dataset.minQuantity);
      const isAvailable = state.selectedQuantity >= minQty;
      
      // Update card availability styling
      card.classList.toggle('opacity-60', !isAvailable);
      card.classList.toggle('cursor-not-allowed', !isAvailable);
      card.classList.toggle('cursor-pointer', isAvailable);
      
      // Update badge indicator
      const badge = document.querySelector(`[data-patch-badge="${patchType}"]`);
      if (badge) {
        if (minQty > 1) {
          if (isAvailable) {
            badge.className = 'absolute top-3 right-3 z-10 px-3 py-2 text-xs font-medium rounded-full bg-green-100 text-green-700 border border-green-300 sb-top';
            badge.innerHTML = '✓ Available';
          } else {
            badge.className = 'absolute top-3 right-3 z-10 px-3 py-2 text-xs font-medium rounded-full bg-orange-100 text-orange-700 border border-orange-300 sb-top';
            badge.innerHTML = `${minQty}+ hats`;
          }
        } else {
          badge.className = 'hidden';
          badge.innerHTML = '';
        }
      }
      
      // Reset patch type if it becomes unavailable
      if (!isAvailable && state.patchType === card.dataset.patchType) {
        state.patchType = '';
        updatePatchTypeUI();
      }
    });

    updatePatchHints();
  }

  function updatePatchHints() {
    const hintContainer = document.querySelector('[data-patch-hints]');
    if (!hintContainer) return;

    let hintHTML = '';
    
    if (state.selectedQuantity < 10) {
      hintHTML = '<div class="text-orange-600 bg-orange-50 px-3 py-2 rounded-lg border border-orange-200">💡 <strong>Tip:</strong> Order 10+ hats to unlock Embroidery option</div>';
    } else if (state.selectedQuantity >= 10 && state.selectedQuantity < 100) {
      hintHTML = '<div class="text-blue-600 bg-blue-50 px-3 py-2 rounded-lg border border-blue-200">💡 <strong>Tip:</strong> Order 100+ hats to unlock premium Rubber Patch option</div>';
    } else {
      hintHTML = '<div class="text-green-600 bg-green-50 px-3 py-2 rounded-lg border border-green-200">🎉 <strong>Congrats!</strong> All patch options are now available including premium Rubber Patch</div>';
    }

    hintContainer.innerHTML = hintHTML;
  }

  function updatePatchTypeUI() {
    document.querySelectorAll('[data-patch-type]').forEach(card => {
      const isSelected = card.dataset.patchType === state.patchType;
      card.classList.toggle('ring-2', isSelected);
      card.classList.toggle('ring-primary', isSelected);
      card.classList.toggle('border-primary', isSelected);
      card.classList.toggle('bg-primary/5', isSelected);
    });
  }

  function showPatchConfiguration(patchType) {
    const configSection = document.querySelector('[data-patch-config]');
    if (!configSection) return;

    // Hide config section entirely for rubber patches
    if (patchType === 'rubber') {
      configSection.style.display = 'none';
      return;
    }

    configSection.style.display = patchType ? 'block' : 'none';

    if (!patchType) return;

    const shapesSection = configSection.querySelector('[data-patch-shapes]');
    const locationsSection = configSection.querySelector('[data-patch-locations]');
    const leatherMaterialsSection = configSection.querySelector('[data-leather-materials]');
    const fabricMaterialsSection = configSection.querySelector('[data-fabric-materials]');
    const embroiderySizeSection = configSection.querySelector('[data-embroidery-size]');
    const descriptionEl = configSection.querySelector('[data-config-description]');

    if (shapesSection) shapesSection.style.display = 'none';
    if (locationsSection) locationsSection.style.display = 'none';
    if (leatherMaterialsSection) leatherMaterialsSection.style.display = 'none';
    if (fabricMaterialsSection) fabricMaterialsSection.style.display = 'none';
    if (embroiderySizeSection) embroiderySizeSection.style.display = 'none';

    if (patchType === 'leather') {
      if (shapesSection) shapesSection.style.display = 'block';
      if (locationsSection) locationsSection.style.display = 'block';
      if (leatherMaterialsSection) leatherMaterialsSection.style.display = 'block';
      if (descriptionEl) descriptionEl.textContent = 'Choose the shape, location, and material for your leather patch';
      setupPatchShapeSelection();
      setupPatchLocationSelection();
      setupLeatherMaterialSelection();
    } else if (patchType === 'fabric') {
      if (shapesSection) shapesSection.style.display = 'block';
      if (locationsSection) locationsSection.style.display = 'block';
      if (fabricMaterialsSection) fabricMaterialsSection.style.display = 'block';
      if (descriptionEl) descriptionEl.textContent = 'Choose the shape, location, and material for your fabric patch';
      setupPatchShapeSelection();
      setupPatchLocationSelection();
      setupFabricMaterialSelection();
    } else if (patchType === 'embroidery') {
      if (embroiderySizeSection) embroiderySizeSection.style.display = 'block';
      if (descriptionEl) descriptionEl.textContent = 'Select the size of your embroidery design';
      setupEmbroiderySizeInput();
    }
  }

  function setupPatchShapeSelection() {
    const shapeCards = document.querySelectorAll('[data-patch-shape]');
    
    shapeCards.forEach(card => {
      card.addEventListener('click', function() {
        shapeCards.forEach(c => {
          c.classList.remove('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
        });
        this.classList.add('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
      });
    });
  }

  function setupPatchLocationSelection() {
    const locationCards = document.querySelectorAll('[data-patch-location]');
    
    locationCards.forEach(card => {
      card.addEventListener('click', function() {
        locationCards.forEach(c => {
          c.classList.remove('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
        });
        this.classList.add('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
      });
    });
  }

  function setupLeatherMaterialSelection() {
    const materialCards = document.querySelectorAll('[data-leather-material]');
    
    materialCards.forEach(card => {
      card.addEventListener('click', function() {
        materialCards.forEach(c => {
          c.classList.remove('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
        });
        this.classList.add('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
      });
    });
  }

  function setupFabricMaterialSelection() {
    const materialCards = document.querySelectorAll('[data-fabric-material]');
    
    materialCards.forEach(card => {
      card.addEventListener('click', function() {
        materialCards.forEach(c => {
          c.classList.remove('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
        });
        this.classList.add('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
      });
    });
  }

  function setupEmbroiderySizeInput() {
    const sizeOptions = document.querySelectorAll('[data-embroidery-size-option]');
    
    sizeOptions.forEach(option => {
      // Remove any existing listeners
      const newOption = option.cloneNode(true);
      option.parentNode.replaceChild(newOption, option);
    });
    
    // Re-query after cloning
    const newSizeOptions = document.querySelectorAll('[data-embroidery-size-option]');
    
    newSizeOptions.forEach(option => {
      option.addEventListener('click', function() {
        // Remove selection from all
        newSizeOptions.forEach(opt => {
          opt.classList.remove('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
        });
        
        // Add selection to clicked
        this.classList.add('ring-2', 'ring-purple-500', 'border-purple-500', 'bg-purple-50');
        
        console.log('Selected embroidery size:', this.dataset.embroiderySizeOption);
      });
    });
  }

  // Hat catalog functionality
  function setupHatCatalog() {
    setupStyleColorSelection();
    setupSizeAllocation();
    setupHorizontalScroll();
  }

  function setupStyleColorSelection() {
    const styleColorCards = document.querySelectorAll('[data-style-color]');
    
    styleColorCards.forEach(card => {
      const decreaseBtn = card.querySelector('[data-decrease]');
      const increaseBtn = card.querySelector('[data-increase]');
      const quantityInput = card.querySelector('[data-quantity-input]');
      const variantSelector = card.querySelector('[data-variant-selector]');
      
      if (decreaseBtn && increaseBtn && quantityInput) {
        decreaseBtn.addEventListener('click', () => {
          const currentVal = parseInt(quantityInput.value) || 0;
          quantityInput.value = Math.max(0, currentVal - 1);
          handleQuantityChange(card, quantityInput.value);
        });
        
        increaseBtn.addEventListener('click', () => {
          const currentVal = parseInt(quantityInput.value) || 0;
          quantityInput.value = currentVal + 1;
          handleQuantityChange(card, quantityInput.value);
        });
        
        quantityInput.addEventListener('input', () => {
          const val = Math.max(0, parseInt(quantityInput.value) || 0);
          quantityInput.value = val;
          handleQuantityChange(card, val);
        });
      }
      
      if (variantSelector) {
        setupVariantControls(card, variantSelector);
      }
    });
  }

  function handleQuantityChange(card, quantity) {
    const variantSelector = card.querySelector('[data-variant-selector]');
    
    if (quantity > 0) {
      if (variantSelector) {
        variantSelector.style.display = 'block';
      }
      card.classList.add('ring-2', 'ring-blue-500', 'bg-blue-50');
    } else {
      if (variantSelector) {
        variantSelector.style.display = 'none';
        variantSelector.querySelectorAll('[data-variant-input]').forEach(input => {
          input.value = 0;
        });
      }
      card.classList.remove('ring-2', 'ring-blue-500', 'bg-blue-50');
    }
    
    updateVariantTotals(card);
    updateStyleColorAllocation();
  }

  function setupVariantControls(card, variantSelector) {
    const variantInputs = variantSelector.querySelectorAll('[data-variant-input]');
    
    variantInputs.forEach(input => {
      const variantId = input.dataset.variantId;
      const decreaseBtn = variantSelector.querySelector(`[data-variant-decrease][data-variant-id="${variantId}"]`);
      const increaseBtn = variantSelector.querySelector(`[data-variant-increase][data-variant-id="${variantId}"]`);
      
      if (decreaseBtn && increaseBtn) {
        decreaseBtn.addEventListener('click', () => {
          const currentVal = parseInt(input.value) || 0;
          input.value = Math.max(0, currentVal - 1);
          updateVariantTotals(card);
          updateStyleColorAllocation();
        });
        
        increaseBtn.addEventListener('click', () => {
          const currentVal = parseInt(input.value) || 0;
          input.value = currentVal + 1;
          updateVariantTotals(card);
          updateStyleColorAllocation();
        });
        
        input.addEventListener('input', () => {
          const val = Math.max(0, parseInt(input.value) || 0);
          input.value = val;
          updateVariantTotals(card);
          updateStyleColorAllocation();
        });
      }
    });
  }

  function updateVariantTotals(card) {
    const quantityInput = card.querySelector('[data-quantity-input]');
    const variantSelector = card.querySelector('[data-variant-selector]');
    const variantTotalEl = card.querySelector('[data-variant-total]');
    
    if (!variantSelector || !variantTotalEl) return;
    
    const targetQty = parseInt(quantityInput.value) || 0;
    let variantTotal = 0;
    
    const variantInputs = variantSelector.querySelectorAll('[data-variant-input]');
    variantInputs.forEach(input => {
      variantTotal += parseInt(input.value) || 0;
    });
    
    if (targetQty === 0) {
      variantTotalEl.textContent = '';
    } else if (variantTotal === targetQty) {
      variantTotalEl.textContent = `✓ All ${targetQty} hats sized`;
      variantTotalEl.className = 'text-xs text-center mt-2 font-medium text-green-600';
    } else if (variantTotal < targetQty) {
      variantTotalEl.textContent = `${variantTotal}/${targetQty} hats sized`;
      variantTotalEl.className = 'text-xs text-center mt-2 font-medium text-orange-600';
    } else {
      variantTotalEl.textContent = `⚠️ Too many! ${variantTotal}/${targetQty}`;
      variantTotalEl.className = 'text-xs text-center mt-2 font-medium text-red-600';
    }
  }

  function updateStyleColorAllocation() {
    const cards = document.querySelectorAll('[data-style-color]');
    let allComplete = true;
    let totalSelected = 0;
    
    cards.forEach(card => {
      const quantityInput = card.querySelector('[data-quantity-input]');
      const targetQty = parseInt(quantityInput?.value) || 0;
      
      if (targetQty > 0) {
        totalSelected += targetQty;
        
        let variantTotal = 0;
        const variantInputs = card.querySelectorAll('[data-variant-input]');
        variantInputs.forEach(input => {
          variantTotal += parseInt(input.value) || 0;
        });
        
        if (variantTotal !== targetQty) {
          allComplete = false;
        }
      }
    });
    
    state.isStyleConfigComplete = (totalSelected > 0 && allComplete);

    // Reset patch type if actual hat count drops below the patch minimum
    if (state.patchType) {
      const patchMinimums = { leather: 1, embroidery: 10, fabric: 1, rubber: 100 };
      const patchMin = patchMinimums[state.patchType] || 1;
      if (totalSelected > 0 && totalSelected < patchMin) {
        state.patchType = '';
        updatePatchTypeUI();
        showPatchConfiguration('');
        updatePatchOptions();
      }
    }

    updateOrderButtonState();
  }

  function setupSizeAllocation() {
    // Handled by setupStyleColorSelection
  }

  function setupHorizontalScroll() {
    const scrollContainers = document.querySelectorAll('[data-scroll-container]');
    
    scrollContainers.forEach(container => {
      const dotsContainer = container.nextElementSibling?.querySelector('[data-scroll-dots]');
      if (!dotsContainer) return;

      container.addEventListener('scroll', () => {
        updateScrollDots(container, dotsContainer);
      });
    });
  }

  function updateScrollDots(container, dotsContainer) {
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;
    
    if (scrollWidth <= clientWidth) return;
    
    const pageWidth = clientWidth;
    const currentPage = Math.round(scrollLeft / pageWidth);
    
    const dots = dotsContainer.querySelectorAll('[data-dot]');
    dots.forEach((dot, index) => {
      dot.classList.toggle('w-6', index === currentPage);
      dot.classList.toggle('bg-blue-600', index === currentPage);
      dot.classList.toggle('w-1.5', index !== currentPage);
      dot.classList.toggle('bg-blue-300', index !== currentPage);
    });
  }

  // Power-ups selection
  function setupPowerUps() {
    const powerUpCards = document.querySelectorAll('[data-powerup]');
    
    if (hasTeProducts()) {
      const powerUpsSection = document.querySelector('[data-powerup]')?.closest('.space-y-4');
      if (powerUpsSection && !powerUpsSection.querySelector('.tee-powerup-warning')) {
        const hint = document.createElement('div');
        hint.className = 'tee-powerup-warning text-sm text-blue-600 bg-blue-50 px-4 py-2 rounded-lg border border-blue-200 mb-4';
        hint.innerHTML = '💡 <strong>Note:</strong> Only one Tee-related power-up can be selected at a time';
        powerUpsSection.insertBefore(hint, powerUpsSection.querySelector('.grid'));
      }
    }
    
    powerUpCards.forEach(card => {
      card.addEventListener('click', function() {
        const powerUpValue = this.dataset.powerup;
        togglePowerUp(powerUpValue);
      });
    });
  }

  function togglePowerUp(powerUpValue) {
    // Intercept rope power-up — show modal instead of toggling directly
    if (powerUpValue === ROPE_POWERUP_VALUE) {
      openRopeModal();
      return;
    }

    // Intercept branded tee holder — show modal
    if (powerUpValue === TEE_HOLDER_POWERUP_VALUE) {
      openTeeModal();
      return;
    }

    const index = state.selectedPowerUps.indexOf(powerUpValue);

    if (index > -1) {
      state.selectedPowerUps.splice(index, 1);
      console.log('Deselected power-up:', powerUpValue);
    } else {
      const isThisTeePowerUp = isTeePowerUp(powerUpValue);
      
      if (isThisTeePowerUp) {
        const removedTee = state.selectedPowerUps.filter(existingPowerUp => isTeePowerUp(existingPowerUp));
        
        state.selectedPowerUps = state.selectedPowerUps.filter(existingPowerUp => {
          return !isTeePowerUp(existingPowerUp);
        });
        
        if (removedTee.length > 0) {
          console.log('Tee power-up selected, auto-deselected other tee power-ups:', removedTee);
          // Clear tee holder state if it was removed by mutual exclusivity
          if (removedTee.includes(TEE_HOLDER_POWERUP_VALUE)) {
            state.teeLeatherMaterial = '';
            state.teeLeatherTitle = '';
            state.teeLeatherVariantId = null;
            state.teeLogoChoice = '';
            state.teeLogoFile = null;
            state.teeLogoBase64 = null;
          }
        }
      }
      
      state.selectedPowerUps.push(powerUpValue);
      console.log('Selected power-up:', powerUpValue, '(isTee:', isThisTeePowerUp, ')');
      console.log('Current selections:', state.selectedPowerUps);
    }

    updatePowerUpUI();
    updatePricing();
  }

  function updatePowerUpUI() {
    document.querySelectorAll('[data-powerup]').forEach(card => {
      const powerUpValue = card.dataset.powerup;
      const isSelected = state.selectedPowerUps.includes(powerUpValue);

      card.classList.toggle('ring-2', isSelected);
      card.classList.toggle('ring-yellow-500', isSelected);
      card.classList.toggle('border-yellow-500', isSelected);
      card.classList.toggle('bg-yellow-50', isSelected);

      // Show rope summary badge on the card
      if (powerUpValue === ROPE_POWERUP_VALUE) {
        let badge = card.querySelector('[data-rope-summary]');
        if (isSelected && state.ropeAction) {
          const actionLabel = state.ropeAction.charAt(0).toUpperCase() + state.ropeAction.slice(1);
          const colorLabel = state.ropeAction === 'remove' ? '' : (' \u2022 ' + state.ropeColor);
          if (!badge) {
            badge = document.createElement('div');
            badge.setAttribute('data-rope-summary', '');
            badge.className = 'mt-1 text-xs font-medium text-yellow-700 bg-yellow-100 px-2 py-0.5 rounded-full inline-block';
            const descEl = card.querySelector('.space-y-1');
            if (descEl) descEl.appendChild(badge);
          }
          badge.textContent = actionLabel + colorLabel;
        } else if (badge) {
          badge.remove();
        }
      }

      // Show tee holder summary badge on the card
      if (powerUpValue === TEE_HOLDER_POWERUP_VALUE) {
        let badge = card.querySelector('[data-tee-summary]');
        if (isSelected && state.teeLeatherTitle) {
          const logoLabel = state.teeLogoChoice === 'same' ? 'Same logo' : 'Custom logo';
          if (!badge) {
            badge = document.createElement('div');
            badge.setAttribute('data-tee-summary', '');
            badge.className = 'mt-1 text-xs font-medium text-green-700 bg-green-100 px-2 py-0.5 rounded-full inline-block';
            const descEl = card.querySelector('.space-y-1');
            if (descEl) descEl.appendChild(badge);
          }
          badge.textContent = state.teeLeatherTitle + ' \u2022 ' + logoLabel;
        } else if (badge) {
          badge.remove();
        }
      }
    });
  }

  // ============================================
  // ROPE MODAL
  // ============================================

  function openRopeModal() {
    const modal = document.querySelector('[data-rope-modal]');
    if (!modal) return;

    // Show/hide the "Clear Selection" link depending on whether rope is active
    let clearLink = modal.querySelector('[data-rope-clear]');
    if (state.selectedPowerUps.includes(ROPE_POWERUP_VALUE)) {
      if (!clearLink) {
        clearLink = document.createElement('button');
        clearLink.setAttribute('data-rope-clear', '');
        clearLink.className = 'text-xs text-red-500 hover:text-red-700 underline';
        clearLink.textContent = 'Clear selection';
        const header = modal.querySelector('.flex.items-center.justify-between');
        if (header) header.appendChild(clearLink);
      }
      clearLink.style.display = '';
      clearLink.onclick = function() {
        state.selectedPowerUps = state.selectedPowerUps.filter(v => v !== ROPE_POWERUP_VALUE);
        state.ropeAction = '';
        state.ropeColor = '';
        updatePowerUpUI();
        updatePricing();
        closeRopeModal();
      };
    } else if (clearLink) {
      clearLink.style.display = 'none';
    }

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeRopeModal() {
    const modal = document.querySelector('[data-rope-modal]');
    if (!modal) return;
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function setupRopeModal() {
    const modal = document.querySelector('[data-rope-modal]');
    if (!modal) return;

    let pendingAction = '';
    let pendingColor = '';

    const confirmBtn = modal.querySelector('[data-rope-confirm]');
    const colorSection = modal.querySelector('[data-rope-color-section]');
    const customColorWrap = modal.querySelector('[data-rope-custom-color]');
    const customColorInput = modal.querySelector('[data-rope-custom-color-input]');

    function resetModal() {
      pendingAction = '';
      pendingColor = '';
      modal.querySelectorAll('[data-rope-action]').forEach(b => {
        b.classList.remove('border-yellow-400', 'bg-yellow-50', 'ring-2', 'ring-yellow-400');
        b.classList.add('border-gray-200');
      });
      modal.querySelectorAll('[data-rope-color]').forEach(b => {
        b.classList.remove('border-yellow-400', 'bg-white', 'ring-2', 'ring-yellow-400');
        b.classList.add('border-transparent');
      });
      if (colorSection) colorSection.style.display = 'none';
      if (customColorWrap) customColorWrap.style.display = 'none';
      if (customColorInput) customColorInput.value = '';
      if (confirmBtn) confirmBtn.disabled = true;
    }

    function updateConfirmState() {
      if (!confirmBtn) return;
      if (pendingAction === 'remove') {
        confirmBtn.disabled = false;
      } else if (pendingAction && pendingColor) {
        if (pendingColor === 'Other') {
          confirmBtn.disabled = !(customColorInput && customColorInput.value.trim());
        } else {
          confirmBtn.disabled = false;
        }
      } else {
        confirmBtn.disabled = true;
      }
    }

    // Action buttons
    modal.querySelectorAll('[data-rope-action]').forEach(btn => {
      btn.addEventListener('click', function() {
        pendingAction = this.dataset.ropeAction;
        pendingColor = '';

        // Update action button styling
        modal.querySelectorAll('[data-rope-action]').forEach(b => {
          b.classList.remove('border-yellow-400', 'bg-yellow-50', 'ring-2', 'ring-yellow-400');
          b.classList.add('border-gray-200');
        });
        this.classList.remove('border-gray-200');
        this.classList.add('border-yellow-400', 'bg-yellow-50', 'ring-2', 'ring-yellow-400');

        // Reset color selection
        modal.querySelectorAll('[data-rope-color]').forEach(b => {
          b.classList.remove('border-yellow-400', 'bg-white', 'ring-2', 'ring-yellow-400');
          b.classList.add('border-transparent');
        });
        if (customColorWrap) customColorWrap.style.display = 'none';
        if (customColorInput) customColorInput.value = '';

        // Show/hide color section
        if (pendingAction === 'remove') {
          if (colorSection) colorSection.style.display = 'none';
        } else {
          if (colorSection) colorSection.style.display = '';
        }

        updateConfirmState();
      });
    });

    // Color buttons
    modal.querySelectorAll('[data-rope-color]').forEach(btn => {
      btn.addEventListener('click', function() {
        pendingColor = this.dataset.ropeColor;

        modal.querySelectorAll('[data-rope-color]').forEach(b => {
          b.classList.remove('border-yellow-400', 'bg-white', 'ring-2', 'ring-yellow-400');
          b.classList.add('border-transparent');
        });
        this.classList.remove('border-transparent');
        this.classList.add('border-yellow-400', 'bg-white', 'ring-2', 'ring-yellow-400');

        // Show/hide custom color input
        if (pendingColor === 'Other') {
          if (customColorWrap) customColorWrap.style.display = '';
          if (customColorInput) customColorInput.focus();
        } else {
          if (customColorWrap) customColorWrap.style.display = 'none';
          if (customColorInput) customColorInput.value = '';
        }

        updateConfirmState();
      });
    });

    // Custom color input
    if (customColorInput) {
      customColorInput.addEventListener('input', updateConfirmState);
    }

    // Confirm
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        state.ropeAction = pendingAction;
        if (pendingAction === 'remove') {
          state.ropeColor = '';
        } else if (pendingColor === 'Other') {
          state.ropeColor = customColorInput ? customColorInput.value.trim() : '';
        } else {
          state.ropeColor = pendingColor;
        }

        // Add rope to selectedPowerUps if not already there
        if (!state.selectedPowerUps.includes(ROPE_POWERUP_VALUE)) {
          state.selectedPowerUps.push(ROPE_POWERUP_VALUE);
        }

        updatePowerUpUI();
        updatePricing();
        closeRopeModal();
        resetModal();
      });
    }

    // Close handlers
    const closeBtn = modal.querySelector('[data-rope-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeRopeModal();
        resetModal();
      });
    }

    const backdrop = modal.querySelector('[data-rope-modal-backdrop]');
    if (backdrop) {
      backdrop.addEventListener('click', function() {
        closeRopeModal();
        resetModal();
      });
    }
  }

// ============================================
// TEE HOLDER MODAL
// ============================================

  function openTeeModal() {
    const modal = document.querySelector('[data-tee-modal]');
    if (!modal) return;

    // Show/hide "Clear Selection" link when tee holder is already active
    let clearLink = modal.querySelector('[data-tee-clear]');
    if (state.selectedPowerUps.includes(TEE_HOLDER_POWERUP_VALUE)) {
      if (!clearLink) {
        clearLink = document.createElement('button');
        clearLink.setAttribute('data-tee-clear', '');
        clearLink.className = 'text-xs text-red-500 hover:text-red-700 underline';
        clearLink.textContent = 'Clear selection';
        const header = modal.querySelector('.flex.items-start.justify-between');
        if (header) header.appendChild(clearLink);
      }
      clearLink.style.display = '';
      clearLink.onclick = function() {
        state.selectedPowerUps = state.selectedPowerUps.filter(v => v !== TEE_HOLDER_POWERUP_VALUE);
        state.teeLeatherMaterial = '';
        state.teeLeatherTitle = '';
        state.teeLeatherVariantId = null;
        state.teeLogoChoice = '';
        state.teeLogoFile = null;
        state.teeLogoBase64 = null;
        updatePowerUpUI();
        updatePricing();
        closeTeeModal();
      };
    } else if (clearLink) {
      clearLink.style.display = 'none';
    }

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeTeeModal() {
    const modal = document.querySelector('[data-tee-modal]');
    if (!modal) return;
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function setupTeeModal() {
    const modal = document.querySelector('[data-tee-modal]');
    if (!modal) return;

    let pendingLeather = '';
    let pendingLeatherTitle = '';
    let pendingLeatherVariantId = null;
    let pendingLogoChoice = '';
    let pendingTeeLogoFile = null;
    let pendingTeeLogoBase64 = null;

    const confirmBtn = modal.querySelector('[data-tee-confirm]');
    const logoSection = modal.querySelector('[data-tee-logo-section]');
    const logoUploadArea = modal.querySelector('[data-tee-logo-upload-area]');
    const logoUploadInput = modal.querySelector('[data-tee-logo-upload]');
    const logoLabel = modal.querySelector('[data-tee-logo-label]');

    function resetModal() {
      pendingLeather = '';
      pendingLeatherTitle = '';
      pendingLeatherVariantId = null;
      pendingLogoChoice = '';
      pendingTeeLogoFile = null;
      pendingTeeLogoBase64 = null;

      modal.querySelectorAll('[data-tee-leather]').forEach(c => {
        c.classList.remove('ring-2', 'ring-green-500', 'border-green-500', 'bg-green-50');
      });
      modal.querySelectorAll('[data-tee-logo-choice]').forEach(b => {
        b.classList.remove('border-green-400', 'bg-green-50', 'ring-2', 'ring-green-400');
        b.classList.add('border-gray-200');
      });
      if (logoSection) logoSection.style.display = 'none';
      if (logoUploadArea) logoUploadArea.style.display = 'none';
      if (logoUploadInput) logoUploadInput.value = '';
      if (logoLabel) logoLabel.textContent = 'Click to upload tee holder logo';
      if (confirmBtn) confirmBtn.disabled = true;
    }

    function updateConfirmState() {
      if (!confirmBtn) return;
      if (!pendingLeather || !pendingLogoChoice) {
        confirmBtn.disabled = true;
        return;
      }
      if (pendingLogoChoice === 'different' && !pendingTeeLogoFile) {
        confirmBtn.disabled = true;
        return;
      }
      confirmBtn.disabled = false;
    }

    // Leather material selection
    modal.querySelectorAll('[data-tee-leather]').forEach(card => {
      card.addEventListener('click', function() {
        pendingLeather = this.dataset.teeLeather;
        pendingLeatherTitle = this.dataset.teeMaterialTitle;
        pendingLeatherVariantId = this.dataset.teeMaterialVariantId;

        modal.querySelectorAll('[data-tee-leather]').forEach(c => {
          c.classList.remove('ring-2', 'ring-green-500', 'border-green-500', 'bg-green-50');
        });
        this.classList.add('ring-2', 'ring-green-500', 'border-green-500', 'bg-green-50');

        // Show logo section (progressive disclosure)
        if (logoSection) logoSection.style.display = '';

        updateConfirmState();
      });
    });

    // Logo choice buttons
    modal.querySelectorAll('[data-tee-logo-choice]').forEach(btn => {
      btn.addEventListener('click', function() {
        pendingLogoChoice = this.dataset.teeLogoChoice;

        modal.querySelectorAll('[data-tee-logo-choice]').forEach(b => {
          b.classList.remove('border-green-400', 'bg-green-50', 'ring-2', 'ring-green-400');
          b.classList.add('border-gray-200');
        });
        this.classList.remove('border-gray-200');
        this.classList.add('border-green-400', 'bg-green-50', 'ring-2', 'ring-green-400');

        if (pendingLogoChoice === 'different') {
          if (logoUploadArea) logoUploadArea.style.display = '';
        } else {
          if (logoUploadArea) logoUploadArea.style.display = 'none';
          pendingTeeLogoFile = null;
          pendingTeeLogoBase64 = null;
        }

        updateConfirmState();
      });
    });

    // File upload handler
    if (logoUploadInput) {
      logoUploadInput.addEventListener('change', function(e) {
        const file = e.target.files[0];
        if (!file) return;

        const fileName = file.name.toLowerCase();
        const ext = fileName.substring(fileName.lastIndexOf('.'));
        const allowedExt = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.pdf', '.eps', '.ai'];

        if (!allowedExt.includes(ext)) {
          alert('Invalid file type.');
          e.target.value = '';
          return;
        }
        if (file.size / (1024 * 1024) > 10) {
          alert('File too large. Maximum 10MB.');
          e.target.value = '';
          return;
        }

        pendingTeeLogoFile = file;

        const reader = new FileReader();
        reader.onload = (ev) => {
          pendingTeeLogoBase64 = ev.target.result;
          if (logoLabel) {
            logoLabel.innerHTML = '<span class="text-green-600 font-medium">\u2713 ' + file.name + '</span>';
          }
          updateConfirmState();
        };
        reader.readAsDataURL(file);
      });
    }

    // Confirm
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        state.teeLeatherMaterial = pendingLeather;
        state.teeLeatherTitle = pendingLeatherTitle;
        state.teeLeatherVariantId = pendingLeatherVariantId ? parseInt(pendingLeatherVariantId, 10) : null;
        state.teeLogoChoice = pendingLogoChoice;

        if (pendingLogoChoice === 'different') {
          state.teeLogoFile = pendingTeeLogoFile;
          state.teeLogoBase64 = pendingTeeLogoBase64;
        } else {
          state.teeLogoFile = null;
          state.teeLogoBase64 = null;
        }

        // Remove any other tee power-up (mutual exclusivity)
        state.selectedPowerUps = state.selectedPowerUps.filter(v => {
          if (v === TEE_HOLDER_POWERUP_VALUE) return false;
          return !isTeePowerUp(v);
        });

        state.selectedPowerUps.push(TEE_HOLDER_POWERUP_VALUE);

        updatePowerUpUI();
        updatePricing();
        closeTeeModal();
        resetModal();
      });
    }

    // Close handlers
    const closeBtn = modal.querySelector('[data-tee-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeTeeModal();
        resetModal();
      });
    }

    const backdrop = modal.querySelector('[data-tee-modal-backdrop]');
    if (backdrop) {
      backdrop.addEventListener('click', function() {
        closeTeeModal();
        resetModal();
      });
    }
  }

// ============================================
// LOGO UPLOAD HANDLER WITH EPS & AI SUPPORT
// ============================================

class LogoUploadManager {
  constructor() {
    this.logoFile = null;
    this.logoBase64 = null;
    this.maxFileSizeMB = 10;
    // Added EPS (.eps) and AI (.ai) MIME types
    this.allowedTypes = [
      'image/png', 
      'image/jpeg', 
      'image/jpg', 
      'image/gif', 
      'image/svg+xml', 
      'application/pdf',
      'application/postscript',  // EPS files
      'application/illustrator',  // AI files (some systems)
      'application/vnd.adobe.illustrator' // AI files (Adobe standard)
    ];
    // Fallback: also check file extensions since MIME types can be unreliable for EPS/AI
    this.allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.pdf', '.eps', '.ai'];
    
    this.init();
  }

  
  init() {
    const uploadInput = document.querySelector('[data-logo-upload]');
    const logoLabel = document.querySelector('[data-logo-label]');
    
    if (!uploadInput) return;
    
    uploadInput.addEventListener('change', (e) => {
      this.handleFileSelect(e, logoLabel);
    });
  }
  
  handleFileSelect(event, labelElement) {
    const file = event.target.files[0];
    
    if (!file) return;
    
    // Get file extension
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
    
    // Validate file type (check both MIME type and extension)
    const validMimeType = this.allowedTypes.includes(file.type);
    const validExtension = this.allowedExtensions.includes(fileExtension);
    
    if (!validMimeType && !validExtension) {
      alert('Invalid file type. Please upload PNG, JPG, GIF, SVG, PDF, EPS, or AI files only.');
      event.target.value = '';
      return;
    }
    
    // Validate file size
    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > this.maxFileSizeMB) {
      alert(`File too large. Maximum size is ${this.maxFileSizeMB}MB. Your file is ${fileSizeMB.toFixed(2)}MB.`);
      event.target.value = '';
      return;
    }
    
    // Store file reference
    this.logoFile = file;
    
    // Convert to base64
    this.convertToBase64(file, labelElement);
  }
  
  convertToBase64(file, labelElement) {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      this.logoBase64 = e.target.result;
      this.updateUI(file, labelElement);
      this.updateOrderStatus();
    };
    
    reader.onerror = () => {
      alert('Error reading file. Please try again.');
    };
    
    reader.readAsDataURL(file);
  }
  
  updateUI(file, labelElement) {
    if (!labelElement) return;
    
    // Determine file type for display
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toUpperCase();
    const isImage = file.type.startsWith('image/') && !fileName.endsWith('.eps');
    
    // Get appropriate icon for non-image files
    const fileIcon = this.getFileIcon(fileExtension);
    
    if (isImage && this.logoBase64) {
      // Show thumbnail for supported image formats
      labelElement.innerHTML = `
        <div class="flex items-center space-x-4">
          <img src="${this.logoBase64}" alt="Logo preview" class="w-16 h-16 object-contain border border-gray-300 rounded">
          <div class="text-left">
            <p class="text-lg font-medium text-green-600">✓ ${file.name}</p>
            <p class="text-sm text-muted-foreground">${(file.size / 1024).toFixed(1)} KB • ${fileExtension}</p>
          </div>
        </div>
      `;
    } else {
      // Show icon for vector/non-previewable files (EPS, AI, PDF)
      labelElement.innerHTML = `
        <div class="flex items-center space-x-4">
          <div class="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 border-2 border-blue-300 rounded-lg">
            ${fileIcon}
          </div>
          <div class="text-left">
            <p class="text-lg font-medium text-green-600">✓ ${file.name}</p>
            <p class="text-sm text-muted-foreground">${(file.size / 1024).toFixed(1)} KB • ${fileExtension}</p>
          </div>
        </div>
      `;
    }
  }
  
  getFileIcon(extension) {
    // Return appropriate SVG icon based on file type
    const iconMap = {
      '.PDF': `<svg class="w-8 h-8 text-red-600" fill="currentColor" viewBox="0 0 20 20">
        <path d="M4 18h12V6h-4V2H4v16zm-2 1V0h12l4 4v16H2v-1z"/>
        <text x="10" y="14" font-size="6" text-anchor="middle" fill="currentColor" font-weight="bold">PDF</text>
      </svg>`,
      '.EPS': `<svg class="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"/>
        <text x="12" y="16" font-size="6" text-anchor="middle" fill="currentColor" font-weight="bold">EPS</text>
      </svg>`,
      '.AI': `<svg class="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
        <text x="12" y="16" font-size="6" text-anchor="middle" fill="currentColor" font-weight="bold">AI</text>
      </svg>`,
      '.SVG': `<svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
      </svg>`
    };
    
    return iconMap[extension] || iconMap['.PDF']; // Default to PDF icon
  }
  
  updateOrderStatus() {
    // Update the status indicator for logo upload
    const indicators = document.querySelectorAll('[data-status-indicator]');
    if (indicators[0]) {
      indicators[0].classList.remove('bg-gray-300', 'text-gray-600');
      indicators[0].classList.add('bg-green-500', 'text-white');
      indicators[0].innerHTML = '✓';
    }
  }
  
  hasLogo() {
    return this.logoFile !== null && this.logoBase64 !== null;
  }
  
  getLogoData() {
    if (!this.hasLogo()) return null;
    
    return {
      fileName: this.logoFile.name,
      fileType: this.logoFile.type || 'application/octet-stream', // Fallback for missing MIME
      fileSize: this.logoFile.size,
      base64Data: this.logoBase64
    };
  }
}
  // Initialize logo manager globally
let logoManager = null;

function initLogoManager() {
  logoManager = new LogoUploadManager();
  console.log('Logo manager initialized');
}

// ============================================
// CLOUDINARY UPLOAD HANDLER
// ============================================

// This Cloudinary account blocks direct .pdf delivery (401), and .eps/.ai don't
// render in browsers — the order gets an image rendition URL instead of the raw file.
function viewableUploadUrl(result) {
  var url = result.secure_url || '';
  if (url.indexOf('/image/upload/') === -1) return url;
  var fmt = (result.format || '').toLowerCase();
  if (fmt === 'pdf' || /\.pdf$/i.test(url)) {
    return url.replace('/image/upload/', '/image/upload/pg_1/').replace(/\.pdf$/i, '.jpg');
  }
  if (fmt === 'eps' || fmt === 'ai' || /\.(eps|ai)$/i.test(url)) {
    return url.replace(/\.(eps|ai)$/i, '.jpg');
  }
  return url;
}

async function uploadLogoToCloudinary(logoData) {
  console.log('=== UPLOADING LOGO TO CLOUDINARY ===');
  
  const CLOUD_NAME = 'dsvcreexw';
  const UPLOAD_PRESET = 'sixhats_custom_logo';
  
  try {
    const formData = new FormData();
    formData.append('file', logoData.base64Data);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', 'hat-orders');
    
    const timestamp = new Date().toISOString();
    formData.append('context', `original_filename=${logoData.fileName}|upload_date=${timestamp}`);
    formData.append('tags', 'hat-order,logo,custom-order');
    
    console.log('Uploading to Cloudinary...');
    console.log('File:', logoData.fileName, `(${(logoData.fileSize / 1024).toFixed(1)} KB)`);
    
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/upload`,
      {
        method: 'POST',
        body: formData
      }
    );
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('Cloudinary upload failed:', errorData);
      throw new Error(errorData.error?.message || 'Upload failed');
    }
    
    const result = await response.json();
    
    console.log('✓ Logo uploaded successfully to Cloudinary');
    console.log('Public URL:', result.secure_url);
    console.log('Public ID:', result.public_id);
    
    return {
      success: true,
      url: viewableUploadUrl(result),
      originalUrl: result.secure_url,
      publicId: result.public_id,
      resourceType: result.resource_type,
      format: result.format,
      bytes: result.bytes,
      createdAt: result.created_at
    };
    
  } catch (error) {
    console.error('Error uploading to Cloudinary:', error);
    return {
      success: false,
      error: error.message
    };
  }
}

  // Scroll buttons
  function setupScrollButtons() {
    const startOrderBtns = document.querySelectorAll('[data-start-order]');
    
    startOrderBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const customizationSection = document.querySelector('[data-customization-section]');
        if (customizationSection) {
          const elementTop = customizationSection.offsetTop;
          const headerOffset = 70;
          const offsetPosition = elementTop - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // Order buttons
  function setupOrderButtons() {
    const finishOrderBtn = document.querySelector('[data-finish-order]');
    
    if (finishOrderBtn) {
      finishOrderBtn.addEventListener('click', function() {
        handleFinishOrder();
      });
    }
  }

function collectPatchConfiguration() {
  const properties = {
    'Patch Type': state.patchType
  };
  
  let isComplete = !!state.patchType;
  let patchMaterialVariantId = null; // NEW: Track patch product variant
  let patchMaterialTitle = null;     // NEW: Track patch product name

  if (state.patchType === 'leather' || state.patchType === 'fabric') {
    const selectedShape = document.querySelector('[data-patch-shape].ring-2');
    if (selectedShape) {
      properties['Patch Shape'] = selectedShape.dataset.patchShape;
    } else {
      isComplete = false;
    }

    const selectedLocation = document.querySelector('[data-patch-location].ring-2');
    if (selectedLocation) {
      properties['Patch Location'] = selectedLocation.dataset.patchLocation;
    } else {
      isComplete = false;
    }

    // Get the selected material
    const materialSelector = state.patchType === 'leather' 
      ? '[data-leather-material].ring-2' 
      : '[data-fabric-material].ring-2';
    
    const selectedMaterial = document.querySelector(materialSelector);
    
    if (selectedMaterial) {
      // Extract variant ID and title
      const variantId = selectedMaterial.dataset.materialVariantId;
      patchMaterialTitle = selectedMaterial.dataset.materialTitle;
      
      console.log('Selected patch material:', {
        type: state.patchType,
        title: patchMaterialTitle,
        variantId: variantId
      });
      
      if (variantId) {
        patchMaterialVariantId = parseInt(variantId, 10);
        properties['Patch Material'] = patchMaterialTitle;
      } else {
        console.error('No variant ID found for selected material');
        isComplete = false;
      }
    } else {
      isComplete = false;
    }
  } else if (state.patchType === 'embroidery') {
    const selectedSize = document.querySelector('[data-embroidery-size-option].ring-2');
    if (selectedSize) {
      const sizeLabel = selectedSize.dataset.sizeLabel;
      properties['Embroidery Size'] = sizeLabel;
      console.log('Embroidery size for cart:', sizeLabel);
    } else {
      isComplete = false;
    }
  } else if (state.patchType === 'rubber') {
    // Rubber patch selected - get product from patch_4_product setting
    const rubberPatchCard = document.querySelector('[data-patch-type="rubber"]');
    if (rubberPatchCard && rubberPatchCard.dataset.patchVariantId) {
      const variantId = rubberPatchCard.dataset.patchVariantId;
      patchMaterialVariantId = parseInt(variantId, 10);
      patchMaterialTitle = rubberPatchCard.dataset.patchTitle || 'Rubber Patch';
      properties['Patch Material'] = patchMaterialTitle;
    } else {
      console.warn('Rubber patch product not configured - please set patch_4_product in theme customizer');
    }
  }

  return { 
    properties, 
    isComplete,
    patchMaterialVariantId,    // NEW: Return variant ID
    patchMaterialTitle          // NEW: Return title
  };
}

  function collectHatSelections() {
    const selections = [];
    const cards = document.querySelectorAll('[data-style-color]');
    
    cards.forEach(card => {
      const variantInputs = card.querySelectorAll('[data-variant-input]');
      
      variantInputs.forEach(input => {
        const quantity = parseInt(input.value) || 0;
        if (quantity > 0) {
          selections.push({
            variantId: input.dataset.variantId,
            quantity: quantity,
            variantTitle: input.dataset.variantTitle,
            backorder: input.dataset.backorder || '',
            backorderStyle: input.dataset.backorderStyle || ''
          });
        }
      });
    });
    
    return selections;
  }

  function collectPowerUpProducts() {
    const powerUpMap = {};
    
    const powerUpElements = document.querySelectorAll('[data-powerup]');
    console.log(`Found ${powerUpElements.length} power-up elements in DOM`);
    
    powerUpElements.forEach(el => {
      const value = el.dataset.powerup;
      const variantId = el.dataset.powerupVariantId;
      
      console.log(`Processing power-up: ${value}`, {
        hasVariantId: !!variantId,
        variantIdValue: variantId,
        variantIdType: typeof variantId
      });
      
      if (variantId) {
        const parsedId = parseInt(variantId, 10);
        if (!isNaN(parsedId) && parsedId > 0) {
          powerUpMap[value] = parsedId;
          console.log(`✓ Power-up mapped: ${value} -> ${parsedId}`);
        } else {
          console.error(`✗ Invalid variant ID for ${value}:`, variantId);
        }
      } else {
        console.warn(`✗ Power-up ${value} has no variant ID in DOM`);
      }
    });
    
    console.log('Final power-up map:', powerUpMap);
    return powerUpMap;
  }

  async function handleFinishOrder() {
    // Validation
    if (!logoManager?.hasLogo() || !state.patchType || !state.isStyleConfigComplete) {
      const missingItems = [];
      if (!logoManager?.hasLogo()) missingItems.push('logo');  // ← Changed from !state.logoFile
      if (!state.patchType) missingItems.push('patch type');
      if (!state.isStyleConfigComplete) missingItems.push('hat configuration');
      
      alert(`Please complete: ${missingItems.join(', ')}`);
      
      const logoSection = document.querySelector('[data-logo-section]');
      if (logoSection) {
        logoSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        logoSection.style.transform = 'scale(1.02)';
        logoSection.style.boxShadow = '0 0 20px rgba(59, 130, 246, 0.5)';
        logoSection.style.transition = 'all 0.3s ease';
        
        setTimeout(() => {
          logoSection.style.transform = '';
          logoSection.style.boxShadow = '';
        }, 3000);
      }
      return;
    }

    // Collect patch configuration
    const patchConfig = collectPatchConfiguration();

    if (!patchConfig.isComplete) {
      alert('Please complete all patch configuration options');
      return;
    }

    // Collect hat selections
    const hatSelections = collectHatSelections();
    if (hatSelections.length === 0) {
      alert('Please select at least one hat style and size');
      return;
    }

    // Calculate total hats
    const totalHats = hatSelections.reduce((sum, item) => sum + item.quantity, 0);

    // Validate total hats meets patch type minimum
    const patchMinimums = { leather: 1, embroidery: 10, fabric: 1, rubber: 100 };
    const patchMin = patchMinimums[state.patchType] || 1;
    if (totalHats < patchMin) {
      alert(`${state.patchType.charAt(0).toUpperCase() + state.patchType.slice(1)} requires a minimum of ${patchMin} hats. You currently have ${totalHats} hat${totalHats === 1 ? '' : 's'} configured.`);
      return;
    }

    // Build cart items array
    const cartItems = [];

    // Back-ordered black sizes: make the customer explicitly acknowledge the timeline before checkout
    const backorders = hatSelections.filter(h => h.backorder);
    if (backorders.length) {
      const lines = backorders.map(h => `• ${h.quantity} × ${h.backorderStyle} ${h.variantTitle} — ${h.backorder}`).join('\n');
      const ok = window.confirm(`BACK-ORDER NOTICE\n\nThese hats are NOT in stock yet:\n${lines}\n\nYour mockup is still made right away, but your whole order ships when the back-ordered hats arrive. Dates are estimates.\n\nPress OK to continue with the back-order, or Cancel to change colours.`);
      if (!ok) return;
    }

// Add hat variants with properties
hatSelections.forEach(hat => {
  cartItems.push({
    id: parseInt(hat.variantId, 10),
    quantity: hat.quantity,
    properties: hat.backorder ? { ...patchConfig.properties, 'Back-Order': hat.backorder } : patchConfig.properties
  });
});

// NEW: Add patch material product to cart (1 per hat)
if (patchConfig.patchMaterialVariantId) {
  if (!isNaN(patchConfig.patchMaterialVariantId) && patchConfig.patchMaterialVariantId > 0) {
    cartItems.push({
      id: patchConfig.patchMaterialVariantId,
      quantity: totalHats,
      properties: {
        '_patch_material': 'true',
        '_patch_type': state.patchType,
        '_applied_to': 'Custom hats order'
      }
    });
  } else {
    console.error('❌ Invalid patch material variant ID:', patchConfig.patchMaterialVariantId);
  }
} else {
  console.warn('⚠️ No patch material variant ID found');
}

    // Add power-ups
    if (state.selectedPowerUps.length > 0) {
      const powerUpProducts = collectPowerUpProducts();

      state.selectedPowerUps.forEach(powerUpValue => {
        const powerUpVariantId = powerUpProducts[powerUpValue];
        if (powerUpVariantId) {
          const variantIdNumber = parseInt(powerUpVariantId, 10);

          if (isNaN(variantIdNumber) || variantIdNumber <= 0) {
            console.error(`Invalid variant ID for ${powerUpValue}:`, powerUpVariantId);
            return;
          }

          const powerUpProps = { '_power_up': powerUpValue };

          // Attach rope options as line item properties
          if (powerUpValue === ROPE_POWERUP_VALUE && state.ropeAction) {
            powerUpProps['Rope'] = state.ropeAction.charAt(0).toUpperCase() + state.ropeAction.slice(1);
            if (state.ropeAction !== 'remove' && state.ropeColor) {
              powerUpProps['Rope Color'] = state.ropeColor;
            }
          }

          // Attach tee holder options as line item properties
          if (powerUpValue === TEE_HOLDER_POWERUP_VALUE) {
            if (state.teeLeatherTitle) {
              powerUpProps['Tee Holder Leather'] = state.teeLeatherTitle;
            }
            powerUpProps['Tee Holder Logo'] = state.teeLogoChoice === 'same' ? 'Same as hat' : 'Custom (see order notes)';
          }

          cartItems.push({
            id: variantIdNumber,
            quantity: totalHats,
            properties: powerUpProps
          });
        } else {
          console.warn(`⚠️ No variant ID found for power-up: ${powerUpValue}`);
        }
      });
    }

    // Show loading state
    const finishBtn = document.querySelector('[data-finish-order]');
    const originalText = finishBtn.textContent;
    finishBtn.disabled = true;
    finishBtn.textContent = 'Processing...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: cartItems })
      });

      const responseData = await response.json();

      if (!response.ok) {
        console.error('Cart API error:', responseData);
        throw new Error(responseData.description || 'Failed to add to cart');
      }

      // Get logo data from manager
      const logoData = logoManager.getLogoData();

      // Upload logo to Cloudinary
      finishBtn.textContent = 'Uploading logo...';

      const uploadResult = await uploadLogoToCloudinary(logoData);

      if (!uploadResult.success) {
        throw new Error(`Logo upload failed: ${uploadResult.error}`);
      }

      // Upload tee holder logo if user chose a different logo
      let teeLogoUploadResult = null;
      if (state.selectedPowerUps.includes(TEE_HOLDER_POWERUP_VALUE) && state.teeLogoChoice === 'different' && state.teeLogoBase64) {
        finishBtn.textContent = 'Uploading tee holder logo...';
        teeLogoUploadResult = await uploadLogoToCloudinary({
          base64Data: state.teeLogoBase64,
          fileName: state.teeLogoFile ? state.teeLogoFile.name : 'tee-holder-logo',
          fileSize: state.teeLogoFile ? state.teeLogoFile.size : 0,
          fileType: state.teeLogoFile ? state.teeLogoFile.type : 'image/png'
        });
        if (!teeLogoUploadResult.success) {
          throw new Error(`Tee holder logo upload failed: ${teeLogoUploadResult.error}`);
        }
      }

      finishBtn.textContent = 'Finalizing order...';

      // Build order note
      let orderNote = `Logo file: ${logoData.fileName} (View: ${uploadResult.url})`;
      if (state.ropeAction) {
        const ropeActionLabel = state.ropeAction.charAt(0).toUpperCase() + state.ropeAction.slice(1);
        orderNote += `\nRope: ${ropeActionLabel}`;
        if (state.ropeAction !== 'remove' && state.ropeColor) {
          orderNote += ` - ${state.ropeColor}`;
        }
      }
      if (state.selectedPowerUps.includes(TEE_HOLDER_POWERUP_VALUE)) {
        orderNote += `\nTee Holder Leather: ${state.teeLeatherTitle || 'Not specified'}`;
        orderNote += `\nTee Holder Logo: ${state.teeLogoChoice === 'same' ? 'Same as hat' : 'Different logo'}`;
        if (teeLogoUploadResult && teeLogoUploadResult.success) {
          orderNote += ` (View: ${teeLogoUploadResult.url})`;
        }
      }

      // Optional per-hat stitching notes + back-order summary
      const stitchNotes = (document.querySelector('[data-stitch-notes]')?.value || '').trim();
      if (stitchNotes) orderNote += `\nStitching colour notes: ${stitchNotes}`;
      const backorderSummary = hatSelections.filter(h => h.backorder).map(h => `${h.quantity} x ${h.backorderStyle} ${h.variantTitle} (${h.backorder})`).join('; ');
      if (backorderSummary) orderNote += `\nBACK-ORDER: ${backorderSummary} — customer acknowledged order ships when stock arrives`;

      // Build cart attributes
      const cartAttributes = {
        'Logo_Filename': logoData.fileName,
        'Logo_File_Type': logoData.fileType,
        'Logo_File_Size': `${(logoData.fileSize / 1024).toFixed(1)} KB`,
        'Logo_URL': uploadResult.url,
        'Logo_Cloudinary_ID': uploadResult.publicId,
        'Logo_Upload_Status': 'Uploaded to Cloudinary',
        'Logo_Upload_Date': new Date().toISOString()
      };
      if (stitchNotes) cartAttributes['Stitching_Notes'] = stitchNotes;
      if (backorderSummary) cartAttributes['Backorder'] = backorderSummary;
      if (state.ropeAction) {
        cartAttributes['Rope_Option'] = state.ropeAction.charAt(0).toUpperCase() + state.ropeAction.slice(1);
        if (state.ropeAction !== 'remove' && state.ropeColor) {
          cartAttributes['Rope_Color'] = state.ropeColor;
        }
      }
      if (state.selectedPowerUps.includes(TEE_HOLDER_POWERUP_VALUE)) {
        cartAttributes['Tee_Holder_Leather'] = state.teeLeatherTitle || 'Not specified';
        cartAttributes['Tee_Holder_Logo_Choice'] = state.teeLogoChoice === 'same' ? 'Same as hat' : 'Different logo';
        if (teeLogoUploadResult && teeLogoUploadResult.success) {
          cartAttributes['Tee_Holder_Logo_URL'] = teeLogoUploadResult.url;
          cartAttributes['Tee_Holder_Logo_Cloudinary_ID'] = teeLogoUploadResult.publicId;
        }
      }

      // Update cart with Cloudinary URL and order details
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          note: orderNote,
          attributes: cartAttributes
        })
      });

      // Redirect to checkout
      window.location.href = '/checkout';

    } catch (error) {
      console.error('Error adding items to cart:', error.message);
      
      alert(`Error adding items to cart: ${error.message}\n\nCheck browser console for details.`);
      finishBtn.disabled = false;
      finishBtn.textContent = originalText;
    }
  }

  function updateOrderButtonState() {
    const finishBtn = document.querySelector('[data-finish-order]');
    const statusIndicators = document.querySelectorAll('[data-status-indicator]');
    
    const hasLogo = logoManager?.hasLogo();
    if (statusIndicators.length >= 3) {
      statusIndicators[0].classList.toggle('bg-green-500', !!hasLogo);
      statusIndicators[0].classList.toggle('text-white', !!hasLogo);
      statusIndicators[0].classList.toggle('bg-gray-300', !hasLogo);

      statusIndicators[1].classList.toggle('bg-green-500', !!state.patchType);
      statusIndicators[1].classList.toggle('text-white', !!state.patchType);
      statusIndicators[1].classList.toggle('bg-gray-300', !state.patchType);

      statusIndicators[2].classList.toggle('bg-green-500', state.isStyleConfigComplete);
      statusIndicators[2].classList.toggle('text-white', state.isStyleConfigComplete);
      statusIndicators[2].classList.toggle('bg-gray-300', !state.isStyleConfigComplete);
    }

    const isReady = hasLogo && state.patchType && state.isStyleConfigComplete;
    
    if (finishBtn) {
      if (isReady) {
        finishBtn.textContent = 'Start Checkout';
        finishBtn.classList.remove('bg-green-600', 'hover:bg-green-700');
        finishBtn.classList.add('bg-primary', 'hover:bg-primary/90');
      } else {
        finishBtn.textContent = 'Finish Setup';
        finishBtn.classList.remove('bg-primary', 'hover:bg-primary/90');
        finishBtn.classList.add('bg-green-600', 'hover:bg-green-700');
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// ============================================
// CONTACT MODAL FUNCTIONALITY
// ============================================
(function() {
  'use strict';

  function initContactModal() {
    const modal = document.querySelector('[data-contact-modal]');
    const openButtons = document.querySelectorAll('[data-open-contact-modal]');
    const closeButtons = document.querySelectorAll('[data-close-modal]');
    const overlay = document.querySelector('[data-modal-overlay]');
    const form = document.querySelector('[data-contact-form]');

    if (!modal) {
      console.warn('Contact modal not found');
      return;
    }

    console.log('Contact modal initialized', {
      modal: !!modal,
      openButtons: openButtons.length,
      closeButtons: closeButtons.length
    });

    function openModal() {
      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      console.log('Modal opened');
    }

    function closeModal() {
      modal.classList.add('hidden');
      document.body.style.overflow = '';
      console.log('Modal closed');
    }

    openButtons.forEach((btn, index) => {
      console.log(`Attaching listener to open button ${index}`, btn);
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
    });

    closeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
        closeModal();
      }
    });

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        
        const formData = new FormData(form);
        const data = Object.fromEntries(formData);
        
        console.log('Contact form submitted:', data);
        alert('Thank you! We\'ll get back to you shortly.');
        
        form.reset();
        closeModal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactModal);
  } else {
    initContactModal();
  }
})();
// Back-order notice (Oct 2026): show the amber notice above "Finish Setup" whenever a back-ordered black size has a quantity
(function() {
  function refreshBackorderNotice() {
    const notice = document.querySelector('[data-backorder-notice]');
    if (!notice) return;
    const items = [...document.querySelectorAll('[data-variant-input][data-backorder]')].filter(i => (parseInt(i.value) || 0) > 0);
    const list = notice.querySelector('[data-backorder-list]');
    if (list) list.innerHTML = items.map(i => `<li>${parseInt(i.value)} × ${i.dataset.backorderStyle} ${i.dataset.variantTitle} — <strong>${i.dataset.backorder}</strong></li>`).join('');
    notice.style.display = items.length ? '' : 'none';
    // one-time heads-up the moment a pre-order size is first added
    const fresh = items.filter(i => !warned.has(i.dataset.variantId));
    if (fresh.length) {
      fresh.forEach(i => warned.add(i.dataset.variantId));
      const i = fresh[0];
      alert(`PRE-ORDER: ${i.dataset.backorderStyle} ${i.dataset.variantTitle} is currently OUT OF STOCK.\n\n${i.dataset.backorder}.\n\nYour mockup is still made right away, but your whole order ships when these hats arrive. Want it sooner? Pick a colour that's in stock.`);
    }
  }
  const warned = new Set();
  const later = () => setTimeout(refreshBackorderNotice, 0);
  document.addEventListener('input', later);
  document.addEventListener('change', later);
  document.addEventListener('click', later);
})();
